var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlyingCube = function SvgFlyingCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-25 0 170 246"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#babccb",
    d: "M61.49 244.477-44.4 185.23l-1.732-121.487 105.89 59.246z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flyingCube_svg__a)",
    d: "M61.49 244.477-44.4 185.23l-1.732-121.487 105.89 59.246z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a8ea6",
    d: "M165.577 182.239 61.49 244.479l-1.732-121.488 104.087-62.24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flyingCube_svg__b)",
    d: "M165.577 182.239 61.49 244.479l-1.732-121.488 104.087-62.24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m59.756 122.991-105.89-59.246L57.954 1.505 163.843 60.75 59.756 122.99z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flyingCube_svg__c)",
    d: "m59.756 122.991-105.89-59.246L57.954 1.505 163.843 60.75 59.756 122.99z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m59.758 122.988-105.89-59.246.076 5.307 105.888 59.176 104.089-62.17-.076-5.307z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flyingCube_svg__a",
    x1: 53.464,
    x2: -47.321,
    y1: 245.422,
    y2: 63.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flyingCube_svg__b",
    x1: 61.907,
    x2: 165.229,
    y1: 196.911,
    y2: 108.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flyingCube_svg__c",
    x1: 57.989,
    x2: 59.721,
    y1: 1.504,
    y2: 122.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })))));
};
export default SvgFlyingCube;